import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as vars from '../../constants/variables';
import { show, hide } from '../../actions/ActivityIndicatorActions';
import { checkAccess } from '../../actions/WelcomeActions';
import { getDetails, getInterests } from '../../actions/AccountActions';
import { getGames } from '../../actions/GamesActions';
import { getCategories } from '../../actions/CategoryActions';
import axios from 'axios';
import { Container, Row, Col} from 'reactstrap';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { console_log, appendUid } from '../../utils/helper';
import { sendData } from '../../analytics/sendData';
import { config } from '../../constants/domainConfig';
import {isGamiclub} from './../../constants/isGamiclub'

class TwoStepLogin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            password: '',
            isValid: false,
            errorMessage: '',
            usernamePwdInvalidated: false, 
            reason: '',
            error: {}
            
        };
        this.onSubmit = this.onSubmit.bind(this);
        this.onChange = this.onChange.bind(this);
        this.isValid = this.isValid.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.callAuthenticate = this.callAuthenticate.bind(this);
        this.callUserApis = this.callUserApis.bind(this);
        this.getCategories = this.getCategories.bind(this);
        this.getGames = this.getGames.bind(this);
    }

    componentDidMount() {
    }

    isValid() {
        if (this.state.username == '') {
            this.setState({
                isValid: false,
                error: {
                    username: true
                }
            });
            return false;
        }
        if (this.state.password == '') {
            this.setState({
                isValid: false,
                error :{
                    password: true
                }
            });
            return false;
        }
        return true;
    }

    onChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    onKeyUp(e) {
        if (e.keyCode == 13) {
            if (this.isValid()) {
                this.setState({ isValid: true, errorMessage: '' });
                this.callAuthenticate({
                    username: this.state.username,
                    password: this.state.password
                });
            }
        }
    }

    onSubmit(e) {
        e.preventDefault();
        if (this.isValid()) {
            this.setState({ isValid: true, errorMessage: '' });
            this.callAuthenticate({
                username: this.state.username,
                password: this.state.password

            });
        }
    }

    callAuthenticate(data) {
        this.props.show();
        axios.post(vars.BASE_URL + `/checkAccessWithUsername`, {
            username: data.username,
            password: data.password,
        })
        .then((response) => {
            let data = {
                success: response.data.success,
                uid: response.data.data.payload.token,
                token: response.data.data.token,
                subscriptionData: response.data.data.payload
            };
            sessionStorage.setItem("authorized", JSON.stringify(data))
            sendData('', '', '', 'Accessed', { method: 'username', status: 'success', url: window.location.href, rid: data.subscriptionData.rockmanId});
            this.props.checkAccess(data);
            if (response.data.success) {
                axios.defaults.headers.common['authorization'] = this.props.access.token;
                this.getCategories()
                this.getGames(this.props.access.uid)
                .then(() => {
                    this.callUserApis(this.props.access.uid) 
                })
                .then(() => {
                    console.log('call apis was successful');
                    this.props.hide();
                    this.props.history.push(appendUid('/welcome', this.props.access.uid));
                })
                .catch(err => {
                    console.log(err);
                    this.props.hide();
                    this.props.history.push('/twoStepLogin');
                })
            }
            else {
                this.setState({
                    error:{
                        api: true
                    },
                    reason: response.data.data.payload.reason
                })
                this.props.hide();
            }
        })
        .catch((error) => {
            this.props.hide();
            console.log(error);
            this.props.history.push("/twoStepLogin");
        });
    }
    callUserApis(uid) {
        return new Promise((resolve, reject) => {
            if (this.props.account.interests.length <= 0) {
                axios.all([axios.get(`${vars.BASE_URL}/interests?uid=${uid}`)])
                    .then(axios.spread((interests) => {
                        if (interests.data.data) {
                            this.props.getInterests(interests.data.data);
                        }
                        resolve();
                    })
                    )
                    .then(() => {
                        axios.get(`${vars.BASE_URL}/getUserProfile?uid=${uid}`)
                            .then((resp) => {
                                if (resp.data.data) {
                                    this.props.getDetails(resp.data.data);
                                }

                            })
                            .catch((err) => {
                                console.log("error in getting user profile twosteplogin1111-------- ", err)
                            })

                    })
                    .catch(err => {
                        console_log(err);
                        reject(err);
                    });
            } else {
                this.props.getDetails(this.props.account.user);
                this.props.getInterests(this.props.account.interests);
                resolve();
            }
        })
    }
    getCategories() {
            axios.get(vars.BASE_URL + '/getCategories')
                .then((response) => {
                    if (response.data.success) {
                        let dataFinal = response.data;
                        let categoriesArr = dataFinal.data;
                        dataFinal = { ...dataFinal, data: categoriesArr };
                        if(config.subDomain == 'sa' || config.subDomain == 'iq' || config.subDomain == 'asiacell' || config.subDomain == 'qa'){
                            dataFinal.data = dataFinal.data.filter(category => {
                                return category.categoryName != 'New Arrivals'
                            })
                        }
                        if(!(config.subDomain === 'ch' && isGamiclub)){
                            dataFinal.data = dataFinal.data.filter(category => {
                                return category.categoryName != 'Astrology'
                            })
                        }
                        if(config.subDomain === 'fr' && isGamiclub) {
                            dataFinal.data = dataFinal.data.filter(category => {
                                return category.categoryName != 'Heróis Verdes'
                            })
                        }
                        if(config.subDomain === 'my' && window.location.hostname.includes('gamiclub')) {
                            dataFinal.data = dataFinal.data.filter(category => {
                                let excludes = ["E-Learning", "Heróis Verdes", "Meu Emprego dos Sonhos", "Political & Activism"]
                                return excludes.indexOf(category.categoryName) == -1
                            })
                        }
                        if(config.subDomain === 'es2' && window.location.hostname.includes('beemobi')) {
                            dataFinal.data = dataFinal.data.filter(category => {
                                let excludes = ["E-Learning", "Heróis Verdes", "Meu Emprego dos Sonhos"]
                                return excludes.indexOf(category.categoryName) == -1
                            })
                        }
                        else {
                            dataFinal.data = dataFinal.data.filter(category => {
                                return category.categoryName != 'Videos Virales'
                            })
                        }
                        if(!(config.subDomain === 'cz' && isGamiclub)){
                            dataFinal.data = dataFinal.data.filter(category => {
                                return category.categoryName != 'E-knihy'
                            })
                        }
                        if(config.subDomain !== 'rs'){
                            dataFinal.data = dataFinal.data.filter(category => {
                                return category.categoryName != 'Е-књиге'
                            })
                        }
                        if(config.subDomain !== 'ae'){
                            dataFinal.data = dataFinal.data.filter(category => {
                                return category.categoryName != 'IQ Games'
                            })
                        }
                        if(config.subDomain != 'maxis' && config.subDomain != 'my' && (config.subDomain != 'sa' && !isGamiclub)){
                            dataFinal.data = dataFinal.data.filter(category => {
                                return category.categoryName != 'Utilities'
                            })
                        }
                        if(config.subDomain != 'idsale' || config.subDomain!='gmn'){
                            dataFinal.data = dataFinal.data.filter(category => {
                                return category.categoryName != 'On Sale'
                            })
                        }
                        if(config.subDomain == 'idsale' || config.subDomain ==='gmn'){
                            dataFinal.data = dataFinal.data.sort(category =>{
                                if(category.categoryName == 'On Sale') return -1;
                                else return 1;
                            })
                        }
                        if(config.subDomain !== 'tr' && config.subDomain !== 'qa' && config.subDomain !== 'kw'){
                            dataFinal.data = dataFinal.data.filter(category => {
                                return category.categoryName != 'Facebook'
                            })
                        }
                        this.props.getCategories(dataFinal);
                        return;
                    }
                })
                .catch((error) => {
                    console_log(error);
                    this.setState({ isValid: false, errorMessage: 'Unable to fetch the data.' });
                    return;
                });
    }

    getGames(uid) {
        return new Promise((resolve, reject) => {
            axios.get(vars.BASE_URL + '/getGames?uid=' + uid)
                .then((response) => {
                    if (response.data.success) {
                        if (!(config.subDomain == 'tr' || config.subDomain == 'no')) {
                            response.data.data = response.data.data.filter(game => {
                                return (game.gameTitle != "Trusted Tarot" && game.gameTitle != "Coffee Reading");
                            })
                        }
                        if(config.subDomain != 'tr'){
                            response.data.data = response.data.data.filter((game) => {
                                return game.gameTitle != 'Okey'
                            })
                        }
                        if(config.subDomain === 'eg'){
                            const excluded_games = ['Santa Claus The Pervert Part 1', 'Place your bets! GTA is getting a real virtual casino', 'Dargavs Welcome to the City of the Dead', 'King Bacon Vs Vegans', 'Jackpot', 'Christmas Night Of Horror', 'High Fly Valentine', 'Horoscope', 'Sacra Terra Kiss Of Death', 'Haunted Legends Undertaker', 'Stereotypo'];
                            response.data.data = response.data.data.filter((game) => {
                                return excluded_games.indexOf(game.gameTitle) < 0
                            })
                        }
                        this.props.getGames(response.data);
                    }
                    resolve();
                })
                .catch((error) => {
                    console_log(error);
                    this.setState({ isValid: false, errorMessage: 'Unable to fetch the data.' });
                    reject(error);
                });
        })
        
    }
    render() {
        // if (!this.state.error.usernamePwdInvalidated) {
            return (
                <div className="login animated fadeIn">
                    <Row className="justify-content-center">
                        <Col>
                            <Row className="login-page-header">
                                <div className="login-page-header-child">
                                    <img className="login-page-logo" src={isGamiclub ? "./img/logo_gamiclub.png" : "./img/logo.png"} alt="GameLord" width="125px" />
                                </div>
                            </Row>
                            <Row className="login-page-content">
                                <h1>
                                    <FormattedMessage id="pleaseLogin"
                                        defaultMessage="Please login to continue"
                                    />
                                </h1>
                                <p>
                                    <FormattedHTMLMessage id="loginUsing"
                                        defaultMessage="Login using the username and password you got in the welcome message"
                                    />
                                </p>

                                <div className="login-page-mobile_num">

                                    {this.state.error.username && <span className="error-message">
                                        <FormattedMessage id="usernameRequired"
                                            defaultMessage="Username is required."
                                        />
                                    </span>}
                                    <input autoFocus type="text" name="username" value={this.state.username} onChange={this.onChange} onKeyUp={this.onKeyUp} className="LoginRoute-number" 
                                        placeholder="Kullanıcı adı" />

                                    {this.state.error.password && <span className="error-message">
                                        <FormattedMessage id="passwordRequired"
                                            defaultMessage="Password is required."
                                        />
                                    </span>}
                                    <input type="password" name="password" value={this.state.password} onChange={this.onChange} onKeyUp={this.onKeyUp} className="LoginRoute-number" 
                                        placeholder="Şifre" /> 

                                    <button type="submit" onClick={this.onSubmit} className="LoginRoute-button">
                                        <FormattedMessage id="login"
                                            defaultMessage="Login"
                                        />
                                        <i className="icon-back"></i>
                                    </button>
                                    {this.state.error.api && <span className="error-message">
                                                                {this.state.reason}
                                                            </span>
                                    }
                                </div>
                            </Row>
                        </Col>
                    </Row>
                </div>
            )
        // }
        // else{
        //     return (<TwoStepLoginFailed reason={this.state.reason} />)
        // } 
    }

}

const TwoStepLoginFailed = (props) => {
    return (
        <Container className="restricted">
            <Row className="justify-content-center">
                <Col md="6">
                    <div className="clearfix">
                        <h1 className="float-left display-3 mr-4 red-text-color"><i className="fa fa-warning"></i></h1>
                        <h4 className="pt-3 golden-text-color" style={{ fontWeight: 800 }}>
                            {props.reason}
                        </h4>
                        <p className="red-text-color float-left">
                            Subscribe now to GameLords for unlimited access to all our HTML5 and Android Games!
                            </p>
                    </div>
                </Col>
            </Row>
        </Container>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.AuthenticationReducer,
        loader: state.ActivityIndicatorReducer,
        access: state.WelcomeReducer,
        account: state.AccountReducer
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        checkAccess,
        show,
        hide,
        getDetails,
        getInterests,
        getGames,
        getCategories,
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(TwoStepLogin);



// WEBPACK FOOTER //
// ./src/components/Login/TwoStepLogin.js